export default __webpack_public_path__ + "static/media/j-scott-rumptz.b72b4c6b.jpg";